import { Link, NavLink } from 'react-router-dom';
import { chipAction, siteContainer, wordmark } from '../lib/ui';
import { DragonMark } from './DragonMark';

/**
 * サイトのヘッダー（`drawgon 公開サイト` のデザイン）。ロゴとワードマーク、トップの節へのリンク、ランキング。
 *
 * 「遊びかた」「系統」はトップの中の節。ほかのページからはトップへ移ってからその節まで送る
 * （送るのは `Home` の `useScrollToHash`）。
 *
 * **選択中は見た目で示さない**（デザインに無い）。`NavLink` が `aria-current="page"` を付ける。
 */
export function SiteHeader() {
  return (
    <header className={`${siteContainer} flex flex-wrap items-center justify-between gap-4 py-5`}>
      <Link to="/" className="flex items-center gap-2.5">
        <DragonMark className="h-[46px] w-[44px] flex-none text-ink" />
        <span className={`${wordmark} text-[29px]`}>drawgon</span>
      </Link>
      <nav aria-label="サイト" className="flex items-center gap-[clamp(12px,3vw,28px)] text-[15px]">
        <Link to={{ pathname: '/', hash: '#howto' }} className="hover:text-blue-dk">
          遊びかた
        </Link>
        <Link to={{ pathname: '/', hash: '#arche' }} className="hover:text-blue-dk">
          系統
        </Link>
        <NavLink to="/rankings" className={chipAction}>
          ランキング <span aria-hidden="true">▶</span>
        </NavLink>
      </nav>
    </header>
  );
}
